(function() {
  'use strict';

  angular
    .module('observatoireApp')
    .config(routesConfig);

  /** @ngInject */
  routesConfig.$inject = ['$stateProvider'];
  function routesConfig($stateProvider) {
    $stateProvider
      .state('main.autorisations-minieres', {
        url: '/autorisations-minieres',
        templateUrl: 'app/autorisations-minieres/autorisations-minieres.html',
        controller: 'AutorisationsMinieresCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Autorisations minières'
        }
      })
      .state('main.autorisations-minieres-details', {
        url: '/autorisations-minieres/:id',
        templateUrl: 'app/autorisations-minieres/autorisations-minieres-details.html',
        controller: 'AutorisationsMinieresDetailsCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: 'Détails d\'une autorisation minière'
        }
      });
  }
})();
